import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Skeleton } from "@mui/material"

import useAlertSettings from "helpers/hooks/useAlertSettings"
import useAlertSettingsWStates from "helpers/hooks/useAlertSettingsStates"
import useDevices from "helpers/hooks/useDevices"
import { getOpenAlertsSummary } from "helpers/utils/alerts"
import Message from "widgets/common/Message"
import NoOpenAlertsCard from "./NoOpenAlertsCard"
import OpenAlertsCard from "./OpenAlertsCard"

const AlertsSummary = () => {
  const { t } = useTranslation()
  const {
    orgAlertSettingsWStates,
    fulfilledTimeStamp,
    isError: statesError,
  } = useAlertSettingsWStates()
  const {
    orgAlertSettings,
    orgActiveAlertSettingsById,
    isError: settingsError,
  } = useAlertSettings()
  const { devsWRelsById, isError: devicesError } = useDevices()

  const summary = useMemo(
    () =>
      getOpenAlertsSummary(
        orgAlertSettingsWStates,
        orgActiveAlertSettingsById,
        devsWRelsById,
      ),
    [orgAlertSettingsWStates, orgActiveAlertSettingsById, devsWRelsById],
  )

  const isError = statesError || settingsError || devicesError
  // No data yet also covers switching orgs, where isLoading stays false
  const isLoading = !orgAlertSettingsWStates || !orgAlertSettings || !devsWRelsById

  return isError ? (
    <Message
      messageKey="error.FETCHING_ITEM"
      messageOptions={{ item: t("alerts.ALERTS") }}
      type="error"
    />
  ) : isLoading ? (
    <Skeleton variant="rounded" height={160} data-testid="alerts-summary-skeleton" />
  ) : summary.openAlerts ? (
    <OpenAlertsCard summary={summary} lastUpdatedAt={fulfilledTimeStamp} />
  ) : (
    <NoOpenAlertsCard lastUpdatedAt={fulfilledTimeStamp} />
  )
}

export default AlertsSummary
